<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  expanded: { type: Boolean, default: true },
  groupLabel: { type: String, required: true },
});

const emit = defineEmits(['toggle']);
const { t } = useI18n();
const ariaLabel = computed(() =>
  props.expanded
    ? t('SALES_PARTIES.LIST.COLLAPSE_GROUP', { group: props.groupLabel })
    : t('SALES_PARTIES.LIST.EXPAND_GROUP', { group: props.groupLabel })
);
</script>

<template>
  <button
    type="button"
    class="rounded-lais-sm p-2 text-lais-text-muted transition hover:bg-lais-bg-soft hover:text-lais-text"
    :aria-expanded="expanded"
    :aria-label="ariaLabel"
    @click="emit('toggle')"
  >
    <span
      class="size-4"
      :class="expanded ? 'i-lucide-chevron-up' : 'i-lucide-chevron-down'"
      aria-hidden="true"
    />
  </button>
</template>
